import React from "react";
import Text from "../../../../../../../../_components/Text";
import Button from "../../../../../../../../_components/Button";
import Row from "../../../../../../../../_components/Layout/Row";
import Column from "../../../../../../../../_components/Layout/Column";

import { _Input } from "../../../../../../../../_components/Input";

const SESSION_STORAGE_KEY = "payment_methods";

import { CreateNFeContext } from "../../../../Context";
import { PaymentContext } from "../../context";
import { getPaymentMethods } from "../../../../../../../../api/payments";
import Discount from "../Discount";
import Invoices from "./Invoices";

const PAYMENT_METHODS_ALLOW_INVOICES = [
  "85b486e2-1cfb-4b09-ae36-6c53c93984a2",
  "2f903e2c-3f25-43aa-81e4-3a803f779a91",
  "66d2e0bb-cd7a-41b1-9422-f955b8aca0d2",
  "2ebd591a-224d-408c-84bc-67870ecee8ec",
  "a6dc5919-9240-49c3-ae79-f599598942c2"
];

import { userNFePayment } from "./hooks";

export default (props) => {
  const elementRef = React.useRef(null);
  const createNFeContext = React.useContext(CreateNFeContext);
  const paymentContext = React.useContext(PaymentContext);
  const [payment, setPayment] = React.useState({});
  const [paymentMethods, setPaymentMethods] = React.useState([]);
  const [disabled, setDisabled] = React.useState(false);

  const setNFePayment = userNFePayment();

  function onChangePaymentMethod(e) {
    const paymentMethod = paymentMethods.filter((p) => p.id === e.value)[0];
    setPayment({
      ...payment,
      payment_method: paymentMethod.id,
      name: paymentMethod.name,
    });
  }

  function addPayment() {
    setNFePayment({
      ...payment,
      value: createNFeContext.nfe.paid_value,
      status: 1,
    });
    setPayment(payment);
  }

  function init() {
    setDisabled(true);
    if (sessionStorage.getItem(SESSION_STORAGE_KEY)) {
      setPaymentMethods(
        JSON.parse(sessionStorage.getItem(SESSION_STORAGE_KEY))
      );
      setDisabled(false);
      setPayment({
        ...payment,
        payment_method: "4bf2b774-3476-49fc-bb26-591e363a415d",
        name: "Dinheiro",
      });
    } else {
      getPaymentMethods()
        .then((resp) => {
          setPaymentMethods(resp);
          sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(resp));
          setPayment({
            ...payment,
            payment_method: "4bf2b774-3476-49fc-bb26-591e363a415d",
            name: "Dinheiro",
          });
        })
        .catch()
        .finally(() => {
          setDisabled(false);
        });
    }
  }
  React.useEffect(init, [elementRef.current]);
  return (
    <Row ref={elementRef}>
      <Column md="6" xs="12">
        <Text fontSize="1.2em" color="primary">
          Forma de Pagamento
        </Text>
        <_Input
          disabled={disabled || paymentContext.disabled}
          onChange={onChangePaymentMethod}
          type="select"
          options={paymentMethods.map((p) => {
            return {
              label: p.name,
              value: p.id,
            };
          })}
        />
        <Discount disabled={disabled} />
      </Column>
      <Column md="6" xs="12">
        <Text fontSize="1.2em" color="primary">
          Valor a pagar
        </Text>
        <_Input
          type="currency"
          disabled={disabled || paymentContext.disabled}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              addPayment();
            }
          }}
          onChange={(e) => {
            createNFeContext.handlers.setPaidValue(e.value);
          }}
          value={createNFeContext.nfe.paid_value}
        />

        {PAYMENT_METHODS_ALLOW_INVOICES.includes(payment.payment_method) ? (
          <Invoices payment={payment} />
        ) : (
          <React.Fragment />
        )}
      </Column>
      <Column
        md="6"
        className="mb-3"
        xs="12"
        hide={PAYMENT_METHODS_ALLOW_INVOICES.includes(payment.payment_method)}
      >
        <Button
          disabled={disabled || paymentContext.disabled}
          data-cy-test="#nfe-issuer-button-add-payment"
          onClick={addPayment}
        >
          Adicionar pagamento
        </Button>
      </Column>
    </Row>
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/components/AddPayment/index.jsx